import { render, staticRenderFns } from "./supEntityReles.vue?vue&type=template&id=3f6617be&scoped=true&"
import script from "./supEntityReles.vue?vue&type=script&lang=js&"
export * from "./supEntityReles.vue?vue&type=script&lang=js&"
import style0 from "./supEntityReles.vue?vue&type=style&index=0&id=3f6617be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6617be",
  null
  
)

component.options.__file = "supEntityReles.vue"
export default component.exports